import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled, useResponsiveValue } from 'dripsy';
import { View } from 'react-native';
import { observer } from 'mobx-react-lite';

import { BaseText, Separator } from '@components';
import { CircularProgressBar } from './CircularProgressBar';
import { ProgressTopText } from './ProgressTopText';
import { useViewerModel } from '@models/Viewer/ViewerModel';

const CardContainer = styled(View)({
  width: '100%',
  height: [null, 149],
  px: ['$6', '$9'],
  py: ['$8', '$9'],
  alignItems: [null, 'center'],
  borderRadius: 6,
  bg: '$background10',
  flexDirection: [null, 'row'],
  justifyContent: [null, 'space-between'],
});

const BarAndTextContainer = styled(View)({
  flexDirection: [null, 'row'],
  alignItems: 'center',
});

const TextContainer = styled(View)({
  maxWidth: [null, 480],
});

const RowContainer = styled(View)({
  flex: 1,
  justifyContent: ['center', 'flex-end'],
  flexDirection: 'row',
});

const ResultContainer = styled(View)({
  flex: [1, 0],
  minWidth: [null, 120],
  alignItems: 'center',
  justifyContent: 'center',
});

const VerticalLine = styled(View)({
  width: 1,
  backgroundColor: '$background30',
});

const Label = styled(BaseText)({
  variant: 'text.medium',
  color: '$background50',
});

const Text = styled(BaseText)({
  variant: 'text.xlarge',
  color: '$text400',
});

export const ProgressCard = observer(() => {
  const { t } = useTranslation();
  const viewer = useViewerModel();
  const isVertical = useResponsiveValue(() => [false, true]);
  const watchProgress = viewer.userWatchProgress;

  return (
    <CardContainer>
      <BarAndTextContainer>
        <CircularProgressBar
          percent={watchProgress.completionPercent}
          size={107}
        />

        <Separator size="$8" vertical={isVertical} />
        <TextContainer>
          <ProgressTopText />
        </TextContainer>
      </BarAndTextContainer>

      <Separator size="$8" vertical={isVertical} />

      <RowContainer>
        <ResultContainer>
          <Label>{t('home.completed')}</Label>
          <Separator size="$4" />
          <Text>
            {`${watchProgress.watchedCount} ${t('home.video')}`}
          </Text>
        </ResultContainer>

        <Separator size={['$0', '$6']} vertical />
        <VerticalLine />
        <Separator size={['$0', '$6']} vertical />

        <ResultContainer>
          <Label>{t('home.total')}</Label>
          <Separator size="$4" />
          <Text>
            {`${watchProgress.totalCount} ${t('home.video')}`}
          </Text>
        </ResultContainer>
      </RowContainer>
    </CardContainer>
  );
});
